import React, { FC, useEffect, useState } from "react";
import { Button, Col, Input, Row, message } from "antd";

import { IModal } from "@types";
import Modal from "@components/Modal";
import { ErrorServices, useUpdateCompanyJobFunctionMutation } from "@services";
import { useTypedSelector } from "@/hooks";

export interface IEditJobFunction extends IModal {
  jfItem: { [key: string]: any };
}

const { TextArea } = Input;

const EditCompanyJobFunction: FC<IEditJobFunction> = ({
  isVisible,
  setIsVisible,
  jfItem,
}) => {
  const { user } = useTypedSelector(state => state.auth);
  const company_id = 110;
  const [jobFunction, setJobFunction] = useState("");
  const [description, setDescription] = useState("");

  const [updateCompanyJobFunction, { isLoading }] =
    useUpdateCompanyJobFunctionMutation();

  useEffect(() => {
    setJobFunction(jfItem?.name || "");
    setDescription(jfItem?.description || "");
  }, [jfItem]);

  const onSubmit = async () => {
    try {
      const response = await updateCompanyJobFunction({
        company_id: company_id,
        company_job_function_id: jfItem?.id,
        name: jobFunction,
        description,
      }).unwrap();

      if (response?.success === false) {
        message.error(response?.message || "Unable to update job function");
        return;
      }

      message.success("Job Function successfully updated");
      closeModal();
    } catch (err: any) {
      ErrorServices(err);
    }
  };

  const closeModal = () => {
    setIsVisible(false);
    setJobFunction("");
    setDescription("");
  };

  return (
    <Modal
      width={544}
      onClose={closeModal}
      footer={[
        <Button
          disabled={!jobFunction.trim() || isLoading}
          onClick={onSubmit}
          key="1"
          type="primary"
          loading={isLoading}
        >
          Update
        </Button>,
        <Button onClick={closeModal} key="2">
          Cancel
        </Button>,
      ]}
      title="Update the Job Function"
      isVisible={isVisible}
    >
      <>
        <Row justify="space-between" className="modal__row">
          <Col span={24}>
            <label>Job Function</label>
            <Input
              value={jobFunction}
              onChange={e => setJobFunction(e.target.value)}
              size="large"
              placeholder="Name of the job function here..."
            />
          </Col>
        </Row>

        <Row
          justify="space-between"
          className="modal__row"
          style={{ marginTop: 16 }}
        >
          <Col span={24}>
            <label>Description</label>
            <TextArea
              value={description}
              onChange={e => setDescription(e.target.value)}
              rows={4}
              placeholder="Description here..."
            />
          </Col>
        </Row>
      </>
    </Modal>
  );
};

export default EditCompanyJobFunction;
